import { createApi } from "../../../../utils/createApi";
import { AxiosError, AxiosResponse } from "axios";
import { universalAPIErrorHandler } from "../../../../utils/universalAPIErrorHandler";
import { NavigateFunction } from "react-router-dom";

export const handleSearchCameras = (
  inputValue: string,
  setSearchCameraResults: React.Dispatch<React.SetStateAction<any>>,
  setSearchingCameras: React.Dispatch<React.SetStateAction<boolean>>,
  setMoreToLoad: React.Dispatch<React.SetStateAction<boolean>>,
  pageNumber: number,
  setPageNumber: React.Dispatch<React.SetStateAction<number>>,
  setLoadingMore: React.Dispatch<React.SetStateAction<boolean>>,
  navigate: NavigateFunction
) => {
  const AxiosUI = createApi(``);

  AxiosUI.get(`camera/search/?search=${inputValue}&page=${pageNumber}`).then(
    (response: AxiosResponse) => {
      if (inputValue === localStorage.searchCameraInputValue) {
        setSearchCameraResults((prevResults: any) => [
          ...prevResults,
          ...response.data.results,
        ]);
        setLoadingMore(false);
        if (response.data.next) {
          setMoreToLoad(true);
          setPageNumber((prevPage) => prevPage + 1);
        } else {
          setMoreToLoad(false);
        }
        setSearchingCameras(false);
      }
    },
    (reason: AxiosError) => {
      const retryFunction = () => {
        handleSearchCameras(
          inputValue,
          setSearchCameraResults,
          setSearchingCameras,
          setMoreToLoad,
          pageNumber,
          setPageNumber,
          setLoadingMore,
          navigate
        );
      };
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        setSearchCameraResults([]);
        setSearchingCameras(false);
        setLoadingMore(false);
        setMoreToLoad(false);
        setPageNumber(1);
      });
    }
  );
};
